import React from 'react'
import { api } from '../lib/api.js'

export default function News() {
  const [items, setItems] = React.useState([])
  const [error, setError] = React.useState('')

  React.useEffect(() => {
    let live = true
    api('/api/news')
      .then((d) => { if (live) setItems(d.items || []) })
      .catch((e) => { if (live) setError(e.message || 'Unable to load news.') })
    return () => { live = false }
  }, [])

  return (
    <div className="mx-auto max-w-6xl px-4 py-12">
      <div className="text-xs tracking-[0.32em] text-white/60">UPDATES</div>
      <h1 className="mt-2 text-3xl md:text-5xl font-semibold">Dev News</h1>
      <p className="mt-4 text-white/60 max-w-3xl">Post patch notes, dev comms, and playtest announcements.</p>

      {error && <div className="mt-6 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-200">{error}</div>}

      <div className="mt-8 space-y-4">
        {items.map((it) => (
          <article key={it.id} className="rounded-2xl border border-white/10 bg-panel/60 glow p-6">
            <div className="text-xs tracking-[0.28em] text-white/50">{it.date}</div>
            <h2 className="mt-2 text-xl md:text-2xl font-semibold">{it.title}</h2>
            <p className="mt-3 text-white/60">{it.body}</p>
          </article>
        ))}
        {items.length === 0 && !error && (
          <div className="rounded-2xl border border-white/10 bg-panel/60 glow p-6 text-white/60">No posts yet. Edit <span className="text-white/80">server/config/news.json</span> and restart the server.</div>
        )}
      </div>
    </div>
  )
}
